module.exports = __webpack_public_path__ + "img/banerFlash.eb598051.png";